// src/screens/Analyzing.js
export const LOAD_MSGS = [
  'Procesando imagen...',
  'Aplicando modelos ACI / ICRI...',
  'Identificando patología...',
  'Generando diagnóstico normado...',
  'Preparando reporte...',
];

export function AnalyzingScreen(container, state, _actions) {
  container.innerHTML = `
    <div class="screen">
      <div class="top-bar">
        <div class="logo">
          <div class="logo-sq"><i class="ti ti-building-factory-2" aria-hidden="true"></i></div>
          <div><div class="logo-name">CONCREPRO</div></div>
        </div>
      </div>
      <div class="screen-body" style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:65vh;text-align:center">
        ${state.image
          ? `<img src="${state.image.dataUrl}" alt="" aria-hidden="true"
               style="width:120px;height:90px;object-fit:cover;border-radius:8px;margin-bottom:22px;opacity:.45;border:1px solid var(--border2)">`
          : ''}
        <div class="pulse" style="width:58px;height:58px;border:2px solid var(--amber);border-radius:50%;display:flex;align-items:center;justify-content:center;margin-bottom:16px" aria-hidden="true">
          <i class="ti ti-microscope" style="font-size:22px;color:var(--amber)"></i>
        </div>
        <div class="mono" style="font-size:11px;color:var(--amber);letter-spacing:.12em;text-transform:uppercase;margin-bottom:8px"
             data-load-msg aria-live="polite" aria-label="Estado del análisis">
          ${LOAD_MSGS[state.loadMsgIndex || 0]}
        </div>
        <div style="font-size:16px;font-weight:500">Analizando patología</div>
        <div style="font-size:13px;color:var(--muted);margin-top:4px">ACI · ICRI · EN 1504 · RILEM</div>
      </div>
    </div>`;
}
